import { renderMainLeftCell, renderMainRightCell, renderSectionHeader, renderRowGaps, renderColumnGaps } from '../helpers';
import format from '_shared_/plugins/format.js';

const $format = format.formatHelpers;

export const expenseModule = data => {
  let moduleString = ``;
  const grossExpRatio = data && data.expenseRatioGross && $format.rawPercent(data.expenseRatioGross);
  const netExpRatio = data && data.expenseRatioNet && $format.rawPercent(data.expenseRatioNet);

  moduleString += renderSectionHeader(data.sectionLabel);
  moduleString += renderRowGaps();
  if (grossExpRatio !== netExpRatio) {
    moduleString += `<tr>`;
    moduleString += renderColumnGaps();
    moduleString += renderMainLeftCell('Gross');
    moduleString += renderMainLeftCell('Net');
    moduleString += `</tr>`;
  }
  moduleString += `<tr>`;
  moduleString += renderMainLeftCell(data.symbol);
  moduleString += renderMainRightCell(grossExpRatio);
  if (grossExpRatio !== netExpRatio) {
    moduleString += renderMainRightCell(netExpRatio);
  }
  moduleString += `</tr>`;
  moduleString += renderRowGaps(2);
  return moduleString;
};
